/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 *
 *
 * @author Nikolay Sviridov
 * @version 1.33.0
 * @since 1.33.0
 */

import { useMemo } from 'react';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { makeSelectTranslationWizardImportSubscribersLimits } from '@modules/internationalization/intSelectors';
import {
    IWizardImportSubscribersLimitsTranslation,
} from '@modules/internationalization/types/wizards/importSubscribersLimits';
import { IRootReducer } from '@reducers/rootReducer';
import { stringFormatParams } from '@utils/stringFormat';

import { EWizardImportSubscribersLimitsSteps } from '../wizardImportSubscribersLimitsConstant';
import { IWizardImportSubscribersLimitsReducer } from '../wizardImportSubscribersLimitsReducer';
import {
    makeSelectWizardImportSubscribersLimitsErrorRowsAmount,
    makeSelectWizardImportSubscribersLimitsFileRowsAmount,
    makeSelectWizardImportSubscribersLimitsRemovedRowsAmount,
} from '../wizardImportSubscribersLimitsSelectors';
import { WizardImportSubscribersLimitsStyled } from './styled/WizardImportSubscribersLimitsStyled';
import WizardImportSubscribersLimitsTable from './WizardImportSubscribersLimitsTable/WizardImportSubscribersLimitsTable';

const WizardImportSubscribersLimitsConfirmation = (props: IConnectedProps) => {
    const {
        errorRowsAmount,
        fileRowsAmount,
        removedRowsAmount,
        translation,
    } = props;

    const stepTranslation = translation[EWizardImportSubscribersLimitsSteps.ConfirmStep];

    const getCorrectRowsAmount = useMemo(() => {
        return fileRowsAmount > (errorRowsAmount + removedRowsAmount)
            ? fileRowsAmount - errorRowsAmount - removedRowsAmount
            : 0;
    }, [errorRowsAmount, fileRowsAmount, removedRowsAmount]);

    return <WizardImportSubscribersLimitsStyled>
        <div className="wizard-import-subscribers-limits__export-errors">
            <div>
                {stringFormatParams(stepTranslation.counterLabel, {
                    correctRowsAmount: getCorrectRowsAmount,
                    fileRowsAmount,
                })}
            </div>
        </div>
        <div className="wizard-import-subscribers-limits__table">
            <WizardImportSubscribersLimitsTable
                translation={translation}
            />
        </div>
    </WizardImportSubscribersLimitsStyled>;
};

export interface IConnectedProps extends Pick<IWizardImportSubscribersLimitsReducer,
    'errorRowsAmount' | 'fileRowsAmount' | 'removedRowsAmount'> {
    translation: IWizardImportSubscribersLimitsTranslation;
}

export const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    errorRowsAmount: makeSelectWizardImportSubscribersLimitsErrorRowsAmount(),
    fileRowsAmount: makeSelectWizardImportSubscribersLimitsFileRowsAmount(),
    removedRowsAmount: makeSelectWizardImportSubscribersLimitsRemovedRowsAmount(),
    translation: makeSelectTranslationWizardImportSubscribersLimits(),
});

export default connect(mapStateToProps) (WizardImportSubscribersLimitsConfirmation);
